<template>
  <v-card color="primary" class="card">
    <v-card-title class="justify-space-between align-center">
      <div class="text-h6 font-weight-bold">Evaluaciones anuales</div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div v-if="!evaluaciones || evaluaciones.length === 0" class="text-center text-subtitle-1">
        No hay evaluaciones anuales registradas.
      </div>
      <v-data-table
        v-else
        :headers="headers"
        :items="sortedEvaluaciones"
        item-key="id"
        class="transparent"
        hide-default-footer
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            dense
            filled
            rounded
            background-color="primary"
            color="secondary"
            class="mb-2"
            hide-details
          ></v-text-field>
        </template>
        <template v-slot:[`item.fecha`]="{ item }">
          <span>{{ item.fecha }}</span>
        </template>
        <template v-slot:[`item.tipo`]="{ item }">
          <span>{{ item.fk_idCatTipoEvaluacion == 6 ? 'Funciones Administrativas' : 'Funciones Operativas' }}</span>
        </template>
        <template v-slot:[`item.estatus`]="{ item }">
          <v-chip
            small
            :color="
              item.fk_idCatEstatusEvaluacion == 3
                ? 'success'
                : item.fk_idCatEstatusEvaluacion == 1
                  ? 'error'
                  : 'secondary'
            "
            dark
          >
            {{ item.CatEstatusEvaluacion ? item.CatEstatusEvaluacion.title : 'Sin estatus' }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="secondary" v-bind="attrs" v-on="on" @click.stop="openEditDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar evaluación</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="secondary"
                v-bind="attrs"
                v-on="on"
                :loading="loading"
                :disabled="loading"
                @click.stop="generateExcel(item)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Descargar evaluación</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="text-center py-4">Sin datos</div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import ExportEvaluacionAnual from '@src/modules/evaluacion-anual/domain/entities/ExportEvaluacionAnual.js'
import EditarEvaluacionAnualFormComponent from './EditarEvaluacionAnualFormComponent.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'EvaluacionesAnualesTable',
  props: {
    evaluaciones: {
      type: Array,
      default: () => [],
    },
    idPersonal: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Estatus', value: 'estatus' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      search: '',
      loading: false,
      buffer: null,
    }
  },
  computed: {
    sortedEvaluaciones() {
      // Ordenar por fecha (formato esperado DD/MM/YYYY) descendente
      const parseFecha = (f) => {
        if (!f || typeof f !== 'string') return 0
        const parts = f.split('/')
        if (parts.length === 3) {
          const [dd, mm, yyyy] = parts
          return new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd)).getTime()
        }
        // Fallback para otros formatos reconocibles por Date.parse
        const t = Date.parse(f)
        return isNaN(t) ? 0 : t
      }
      return [...this.evaluaciones].sort((a, b) => parseFecha(b.fecha) - parseFecha(a.fecha))
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('personal', ['fetchEvaluadores']),

    async openEditDialog(evaluacion) {
      await this.fetchEvaluadores(evaluacion.PersonalEvaluador.CUIP)
      this.SET_DIALOG({
        type: 'EDITAR_EVALUACION_ANUAL',
        title: 'Editar evaluación anual',
        component: EditarEvaluacionAnualFormComponent,
        width: '90vw',
        props: {
          evaluacion,
          idPersonal: this.idPersonal,
        },
      })
    },

    async generateExcel(evaluacion) {
      this.loading = true
      try {
        const exporter = new ExportEvaluacionAnual(evaluacion, this.getFullName)
        await exporter.generateXlsx()
      } catch (e) {
        console.log('Error al generar excel evaluación anual', e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
